<template>
  <div>
    <LoadingWidget v-if="loading" />

    <transition :name="transition">
      <div v-if="!loading">
        <div v-if="conditional">
          <slot />
        </div>

        <v-container v-else>
          <v-alert type="info">
            {{ alertMessage }}
          </v-alert>
        </v-container>
      </div>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../widgets/LoadingWidget.vue";

export default {
  props: {
    transition: {
      type: String,
      default: "slideUp", // fade, slideUp
    },
    loading: {
      type: Boolean,
      default: false,
    },
    conditional: {
      type: Boolean,
      default: true,
    },
    alertMessage: {
      type: String,
      default: "Nenhum conteúdo encontrado.",
    },
  },
  components: {
    LoadingWidget,
  },
};
</script>
